import http from '../api';

let getAll = async (data) => {
  const response = await http.get(`projects/${data}`);
  return response;
};
let get = async (data) => {
  const response = await http.get(
    `projects/${data.id}?workspace_id=${data.workspace_id}`,
    data,
  );
  return response;
};
let store = (data) => {
  return http.post('projects', data);
};
let update = (data) => {
  return http.put(`projects/${data.id}`, data);
};

let dashboard = (data) => {
  return http.get(`projects-dashboard/${data}`);
};

let getFirstLastProjectTaskDate = (data) => {
  return http.get(`first-last-project-task-date/${data}`);
};
// let activateCosts = (data) => {
//   return http.put(`activate-costs/${data.id}`, data);
// };

let deletee = (data) => {
  return http.delete(`projects?id=${data.id}&type=${data.type}`);
};

let unDelete = (data) => {
  return http.put(`projects-undelete?id=${data.id}`);
};

let getProjectDefaultStages = async () => {
  const response = await http.get('default-projects-stages');
  return response;
};

let getProjectStages = async (data) => {
  const response = await http.get(`project-stages/${data.project_id}`);
  return response;
};

let deleteProjectStage = (id) => {
  return http.delete(`project-stages/${id}`);
};

let updatePlanning = (id, data) => {
  return http.put(`update-project-planning/${id}`, { data });
};

export default {
  getAll,
  store,
  get,
  update,
  dashboard,
  unDelete,
  //   activateCosts,
  deletee,
  getProjectDefaultStages,
  getProjectStages,
  deleteProjectStage,
  updatePlanning,
  getFirstLastProjectTaskDate,
};
